import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function Work() {
  return <div className="min-h-screen bg-[#FAF7F2]" data-id="element-1028">
      <Header data-id="element-1029" />
      <main className="pt-32 pb-20 px-10" data-id="element-1030">
        <div className="max-w-[1400px] mx-auto" data-id="element-1031">
          <h1 className="text-[#2C2416] text-[clamp(48px,6vw,64px)] font-light leading-[1.1] tracking-[-3px] mb-6 font-['Inter']" data-id="element-1032">
            Our <span className="text-[#D4A574]" data-id="element-1033">Work</span>
          </h1>
          <p className="text-[#8B7355] text-xl max-w-2xl mb-10 leading-relaxed font-['Inter']" data-id="element-1034">
            Explore our portfolio of successful projects and case studies.
          </p>
          {/* Placeholder content - can be expanded later */}
          <div className="bg-white p-12 rounded-xl shadow-md" data-id="element-1035">
            <p className="text-[#8B7355] mb-6" data-id="element-1036">
              This is the Work page. Case studies coming soon.
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-1037" />
    </div>;
}